import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IActivity } from 'app/shared/model/activity.model';
import { getEntities as getActivitiesFirstPage } from 'app/entities/activity/activity.reducer';
import { IActivityImage } from 'app/shared/model/activity-image.model';
import { getEntity, updateEntity, createEntity, reset } from './activity-image.reducer';
import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { IQueryParams, serializeAxiosError } from 'app/shared/reducers/reducer.utils';

export const ActivityImageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const activities = useAppSelector(state => state.activity.entities);
  const activityImageEntity = useAppSelector(state => state.activityImage.entity);
  const loading = useAppSelector(state => state.activityImage.loading);
  const updating = useAppSelector(state => state.activityImage.updating);
  const updateSuccess = useAppSelector(state => state.activityImage.updateSuccess);
  const [inputValue, setInputValue] = useState('');

  const getActivities = createAsyncThunk('activity/fetch_entity_list', async (kw: string) => {
    if (kw.length < 4) return [];
    const requestUrl = `/api/home/activity-byname?name=${kw}`;
    return axios.get<IActivity[]>(requestUrl);
  });

  const getActivityList = createAsyncThunk('activity/fetch_entity_list', async (id: number | string) => {
    const requestUrl = `/api/home/activity-by-image-id-as-array?activityImageId=${id}`;
    return axios.get<IActivity[]>(requestUrl);
  });

  const handleInputChange = event => {
    setInputValue(event?.target?.value);
    if (event?.target?.value?.length < 4) return;
    dispatch(getActivities(event.target.value));
  };

  const handleClose = () => {
    navigate('/activity-image' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      dispatch(getActivitiesFirstPage({}));
    } else {
      const actImage = getEntity(id);
      dispatch(actImage);
      dispatch(getActivityList(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...activityImageEntity,
      ...values,
      activity: activities.find(it => it.id.toString() === values.activity.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...activityImageEntity,
          activity: activityImageEntity?.activity?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.activityImage.home.createOrEditLabel" data-cy="ActivityImageCreateUpdateHeading">
            <Translate contentKey="activitiesApp.activityImage.home.createOrEditLabel">Create or edit a ActivityImage</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="activity-image-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                type="text"
                onChange={handleInputChange}
                placeholder="Type to search..."
                id="activity-filter"
                data-cy="activity"
                value={inputValue}
                name="activity-filter"
                label="Type minimum 4 letters to filter activities"
                //label={ "Type to filter activities. "+ ( "Current attached : " +activityImageEntity?.activity ?  activityImageEntity?.activity?.name : "None" )}
              ></ValidatedField>
              <ValidatedField
                id="activity-image-activity"
                name="activity"
                data-cy="activity"
                label={translate('activitiesApp.activityImage.activity')}
                type="select"
                size={10}
              >
                <option value="" key="0" />
                {activities
                  ? activities.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('activitiesApp.activityImage.name')}
                id="activity-image-name"
                name="name"
                required
                data-cy="name"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.activityImage.imageShortDescription')}
                id="activity-image-imageShortDescription"
                name="imageShortDescription"
                data-cy="imageShortDescription"
                type="text"
                required
              />
              <ValidatedField
                label={translate('activitiesApp.activityImage.imageDescription')}
                id="activity-image-imageDescription"
                name="imageDescription"
                data-cy="imageDescription"
                type="text"
                required
              />
              <ValidatedBlobField
                label={translate('activitiesApp.activityImage.activityImage')}
                id="activity-image-activityImage"
                name="activityImage"
                data-cy="activityImage"
                isImage
                accept="image/*"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/activity-image" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ActivityImageUpdate;
